﻿
const nav=document.getElementById('nav');
window.addEventListener('scroll',()=>nav.classList.toggle('scrolled',window.scrollY>60));

const obs=new IntersectionObserver(entries=>{
  entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('on');obs.unobserve(e.target)}});
},{threshold:.1});
document.querySelectorAll('.reveal').forEach(el=>obs.observe(el));

const colorImgs=window.moonCaseColorImgs||{};

const colorUrls={
  'Black':         'https://www.mooncase.ro/products/black-mooncase',
  'Silver':        'https://www.mooncase.ro/products/silver-mooncase',
  'Gold':          'https://www.mooncase.ro/products/gold-mooncase-1',
  'Titanium Blue': 'https://www.mooncase.ro/products/gold-mooncase'
};

let selectedColor='Black';

function pickColor(el,name){
  document.querySelectorAll('.sw').forEach(s=>s.classList.remove('on'));
  el.classList.add('on');
  selectedColor=name;
  document.getElementById('swName').textContent=name;
  const img=document.getElementById('prodImg');
  img.style.opacity='0';
  setTimeout(()=>{img.src=colorImgs[name];img.style.opacity='1';},200);
  const lbl=document.getElementById('prodImgLabel');if(lbl)lbl.textContent='MoonCase · Aliaj Titan · '+name;
}

function goToProduct(){
  const url=colorUrls[selectedColor];
  if(url) window.location.href=url;
}


function addToCart(btn){
  const orig=btn.textContent;
  btn.textContent='✓ Adăugat!';
  const prevStyle=btn.style.cssText;
  btn.style.cssText='background:linear-gradient(135deg,#166534,#15803d);border:none;color:#fff';
  setTimeout(()=>{btn.textContent=orig;btn.style.cssText=prevStyle},2200);
}
